import { Injectable } from '@angular/core'
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http'
import { Observable, from, switchMap, catchError } from 'rxjs'

import { environment } from '../../../environments/environment'
import { throwIfCustomError } from '../../util/throwIfCustomError'
import { FirebaseTokenProvider } from '../roleplay/active-session-count.service'

/** トライダッシュボード アクセス状況レポートエクスポート API サービス */
@Injectable({ providedIn: 'root' })
export class TrygroupAccessReportExportService {
  private readonly baseUrl = environment.graphqlUrl.replace(/\/$/, '')

  constructor(
    private readonly http: HttpClient,
    private readonly tokenProvider: FirebaseTokenProvider,
  ) {}

  /**
   * アクセス状況レポートエクスポート API に GET リクエストを送り Blob レスポンスを返す
   * @param startDate 開始日（YYYY-MM-DD、JST 基準の集計対象日）
   * @param endDate 終了日（YYYY-MM-DD、JST 基準の集計対象日）
   */
  exportAccessReport(
    startDate: string,
    endDate: string,
  ): Observable<HttpResponse<Blob>> {
    return from(this.tokenProvider.getIdToken()).pipe(
      switchMap((token: string) => {
        const headers = new HttpHeaders({
          Authorization: `Bearer ${token}`,
        })

        const queryParams = new URLSearchParams()
        queryParams.set('startDate', startDate)
        queryParams.set('endDate', endDate)

        const url = `${this.baseUrl}/api/export/trygroup-access-report?${queryParams.toString()}`

        return this.http.get(url, {
          headers,
          responseType: 'blob',
          observe: 'response',
        })
      }),
      catchError((error: unknown) => {
        throwIfCustomError(error)
        throw error
      }),
    )
  }
}
